
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smoothstep = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  function rng(seed) { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; }

  /* ---------- split headlines into words and characters ---------- */
  $$('.split').forEach((el, n) => {
    const text = el.textContent.trim();
    const r = rng(1234 + n * 97);
    const sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = text;
    const vis = document.createElement('span'); vis.className = 'vis'; vis.setAttribute('aria-hidden', 'true');
    const words = text.split(' ');
    const total = text.replace(/ /g, '').length;
    let ci = 0;
    words.forEach((w, wi) => {
      const ws = document.createElement('span'); ws.className = 'w';
      ws.style.setProperty('--th', (wi / words.length * 0.5).toFixed(3));
      for (const ch of w) {
        const c = document.createElement('span'); c.className = 'c'; c.textContent = ch;
        c.style.setProperty('--th', (ci / total * 0.5 + r() * 0.06).toFixed(3));
        c.style.setProperty('--jy', ((ci % 2 ? 1 : -1) * (12 + r() * 16)).toFixed(1) + 'px');
        ws.appendChild(c); ci++;
      }
      vis.appendChild(ws);
      if (wi < words.length - 1) vis.appendChild(document.createTextNode(' '));
    });
    el.textContent = ''; el.append(sr, vis);
  });

  /* ---------- the scrub hero ---------- */
  const HERO = document.getElementById('top');
  const VIDEO_URL = HERO.dataset.video, POSTER = HERO.dataset.poster, ENDING = HERO.dataset.ending;
  const VIDEO_BYTES = 3833199;
  const hero = $('#top'), stage = $('.stage'), video = $('#hero-video');
  const posterLayer = $('.poster'), ring = $('.ring'), cue = $('.cue');
  const bands = $$('.band').map(el => ({ el, a: +el.dataset.a, b: +el.dataset.b, ramp: +el.dataset.ramp || 0, op: -1, k: -1, live: null }));
  let loadK = 0, cueGone = null, failed = false, stageLate = false;

  function heroProgress() {
    const range = hero.offsetHeight - innerHeight;
    return range > 0 ? clamp(-hero.getBoundingClientRect().top / range, 0, 1) : 0;
  }

  function updateCaptions(p) {
    bands.forEach((B, i) => {
      const { a, b } = B, last = i === bands.length - 1;
      const f = Math.min(0.036, (b - a) / 3);
      const op = (i === 0 ? 1 : smoothstep(p, a, a + f)) * (last ? 1 : 1 - smoothstep(p, b - f, b));
      let k = clamp((p - a) / (B.ramp || Math.min(0.025, (b - a) * 0.35)), 0, 1);
      if (i === 0) k = Math.max(k, loadK);
      if (Math.abs(op - B.op) > 0.004 || ((op === 0 || op === 1) && op !== B.op)) {
        B.op = op; B.el.style.opacity = op.toFixed(3);
        const live = op > 0.6;
        if (live !== B.live) { B.live = live; B.el.classList.toggle('live', live); B.el.inert = !live; }   // only the band on screen can be clicked or tabbed to
      }
      if (Math.abs(k - B.k) >= 0.008 || ((k === 0 || k === 1) && k !== B.k)) { B.k = k; B.el.style.setProperty('--k', k.toFixed(3)); }
    });
    const late = failed && p > 0.6;
    if (late !== stageLate) { stageLate = late; stage.classList.toggle('late', late); }
    const gone = p > 0.04;
    if (gone !== cueGone) { cueGone = gone; cue.classList.toggle('gone', gone); }
  }

  // seeks: gated, coalesced, deadlock-safe
  let seekBusy = false, pendingTime = null;
  function requestSeek(t) {
    if (!video.duration || !videoReady) return;
    t = clamp(t, 0, video.duration - 0.04);
    if (seekBusy) { pendingTime = t; return; }
    if (Math.abs(video.currentTime - t) < 0.001) return;
    seekBusy = true;
    video.currentTime = t;
  }
  video.addEventListener('seeked', () => {
    seekBusy = false;
    if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); }
  });
  video.addEventListener('error', () => { seekBusy = false; pendingTime = null; failVideo(); });

  // lerp loop that rests
  let target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = true, videoReady = false;
  function tick(now) {
    const dt = Math.min(100, now - (lastTick || now));
    lastTick = now;
    shown += (target - shown) * (1 - Math.pow(1 - 0.14, dt / 16.667));
    if (Math.abs(target - shown) < 0.0005) { shown = target; rafId = null; lastTick = 0; }
    else rafId = requestAnimationFrame(tick);
    if (videoReady) requestSeek(shown * video.duration);
    updateCaptions(shown);
  }
  function onScroll() {
    target = heroProgress();
    if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick);
  }
  new IntersectionObserver(([e]) => {
    heroOnScreen = e.isIntersecting;
    if (heroOnScreen && scrubOn) onScroll();
  }).observe(hero);

  // band one assembles on load, then hands over to scroll
  function loadRamp() {
    const t0 = performance.now();
    const step = now => {
      const t = clamp((now - t0) / 1300, 0, 1);
      loadK = 1 - Math.pow(1 - t, 3);
      updateCaptions(shown);
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  // poster first, then stream the video behind an honest ring
  let heroInit = false, started = false;
  function initHeroOnce() {
    if (heroInit) return; heroInit = true;
    posterLayer.style.backgroundImage = `url('${POSTER}')`;
    const img = new Image();
    img.onload = startBlobFetch; img.onerror = startBlobFetch;
    img.src = POSTER;
    setTimeout(startBlobFetch, 4000);
    loadRamp();
  }
  function startBlobFetch() {
    if (started) return; started = true;
    loadHeroBlob().catch(failVideo);
  }
  async function loadHeroBlob() {
    const ctrl = new AbortController();
    let watchdog = setTimeout(() => ctrl.abort(), 20000);
    const res = await fetch(VIDEO_URL, { priority: 'low', signal: ctrl.signal });
    if (!res.ok) throw new Error('video ' + res.status);
    const total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
    const reader = res.body.getReader();
    const chunks = []; let got = 0, lastRing = 0;
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      clearTimeout(watchdog); watchdog = setTimeout(() => ctrl.abort(), 20000);
      chunks.push(value); got += value.length;
      const frac = Math.min(1, got / total), now = performance.now();
      if (now - lastRing > 100 || frac === 1) { lastRing = now; ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
    }
    clearTimeout(watchdog);
    ring.style.setProperty('--ld', 0);
    video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
    video.load();
    video.addEventListener('canplay', () => {
      videoReady = true;
      requestSeek(heroProgress() * video.duration);
      stage.classList.add('video-ready');
    }, { once: true });
  }
  function failVideo() {
    if (failed) return; failed = true;
    $('.poster-end').style.backgroundImage = `url('${ENDING}')`;
    stage.classList.add('video-failed');
    updateCaptions(shown);
  }

  /* ---------- the five static-hero gates, live ---------- */
  const GATES = [
    '(max-width: 720px)',
    '(orientation: portrait) and (max-width: 1024px)',
    '(orientation: portrait) and (pointer: coarse)',
    '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
    '(prefers-reduced-motion: reduce)'
  ];
  let scrubOn = false;
  function enableScrub() {
    if (scrubOn) return; scrubOn = true;
    initHeroOnce();
    addEventListener('scroll', onScroll, { passive: true });
    bands.forEach(b => { b.op = -1; b.k = -1; b.live = null; });
    cueGone = null;
    unpinFinalStates();
    shown = target = heroProgress();
    updateCaptions(shown);
    onScroll();
  }
  function disableScrub() {
    if (!scrubOn) return; scrubOn = false;
    removeEventListener('scroll', onScroll);
    if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; lastTick = 0; }
  }
  function applyHeroMode() {
    if (GATES.some(q => matchMedia(q).matches)) disableScrub(); else enableScrub();
  }
  const MQLS = GATES.map(q => matchMedia(q));
  MQLS.forEach(m => m.addEventListener('change', applyHeroMode));

  /* ---------- nav state ---------- */
  const nav = $('.nav'); let navScrolled = null;
  function navState() { const s = scrollY > 40; if (s !== navScrolled) { navScrolled = s; nav.classList.toggle('scrolled', s); } }
  addEventListener('scroll', navState, { passive: true }); navState();

  /* ---------- the stitch that sews itself down the page ---------- */
  const below = $('#below'), stitch = $('.stitch'), seam = $('.seam', stitch), maskPath = $('.mask-path', stitch);
  const needle = $('.needle', stitch), glow = $('.glow', stitch);
  let seamLen = 0, seamP = -1, seamPinned = false, seamRaf = null, stStart = 0;
  function buildStitch() {
    stStart = hero.offsetTop + hero.offsetHeight - below.offsetTop;   // the stitch starts where the hero ends
    const h = below.offsetHeight - stStart;
    stitch.style.top = stStart + 'px'; stitch.style.height = h + 'px';
    stitch.setAttribute('viewBox', `0 0 64 ${h}`);
    let d = 'M32 0'; const seg = 360;
    for (let y = 0, i = 0; y < h; y += seg, i++) {
      const x = i % 2 ? 50 : 14, y2 = Math.min(h, y + seg);
      d += ` C${x} ${y + seg * 0.33} ${x} ${y + seg * 0.66} 32 ${y2}`;
    }
    seam.setAttribute('d', d); maskPath.setAttribute('d', d);
    seamLen = seam.getTotalLength();
    maskPath.style.strokeDasharray = seamLen;
    seamP = -1; drawStitch();
  }
  function drawStitch() {
    seamRaf = null;
    const r = below.getBoundingClientRect();
    const p = seamPinned ? 1 : clamp((innerHeight * 0.75 - r.top - stStart) / (r.height - stStart), 0, 1);
    if (Math.abs(p - seamP) < 0.0008) return;
    seamP = p;
    maskPath.style.strokeDashoffset = (seamLen * (1 - p)).toFixed(1);
    const pt = seam.getPointAtLength(seamLen * p);
    needle.setAttribute('cx', pt.x.toFixed(1)); needle.setAttribute('cy', pt.y.toFixed(1));
    glow.setAttribute('cx', pt.x.toFixed(1)); glow.setAttribute('cy', pt.y.toFixed(1));
  }
  addEventListener('scroll', () => { if (seamRaf === null) seamRaf = requestAnimationFrame(drawStitch); }, { passive: true });
  let rsT; addEventListener('resize', () => { clearTimeout(rsT); rsT = setTimeout(buildStitch, 150); });
  addEventListener('load', buildStitch);
  buildStitch();

  /* ---------- press to pour (hold fills the bowl, letting go flows it back) ---------- */
  const sq = $('#try'), press = $('#press'), meter = $('.meter', sq);
  const HOLD = 1600;
  let prog = 0, holding = false, sprung = false, sqRaf = null, sqLast = 0, sqPinned = false;
  function sqWrite() { press.style.setProperty('--p', prog.toFixed(3)); meter.style.setProperty('--p', prog.toFixed(3)); }
  function sqStep(now) {
    const dt = Math.min(64, now - (sqLast || now)); sqLast = now;
    prog = holding ? Math.min(1, prog + dt / HOLD) : Math.max(0, prog - dt / (sprung ? 1500 : 900));
    sqWrite();
    if (prog >= 1 && !sprung) fullBowl();
    if (holding || prog > 0) sqRaf = requestAnimationFrame(sqStep); else { sqRaf = null; sqLast = 0; }
  }
  function fullBowl() {
    sprung = true; holding = false; press.classList.remove('down');
    sq.classList.add('sprung');
    setTimeout(() => sq.classList.add('settled'), 1400);
  }
  function startHold() {
    if (sprung) { sq.classList.remove('sprung', 'settled'); sprung = false; void sq.offsetWidth; }
    holding = true; press.classList.add('down');
    if (sqRaf === null) sqRaf = requestAnimationFrame(sqStep);
  }
  function endHold() {
    holding = false; press.classList.remove('down');
    if (sqRaf === null && prog > 0) sqRaf = requestAnimationFrame(sqStep);
  }
  press.addEventListener('pointerdown', e => { e.preventDefault(); press.setPointerCapture(e.pointerId); startHold(); });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => press.addEventListener(t, endHold));
  press.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); startHold(); } });
  press.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') endHold(); });
  press.addEventListener('contextmenu', e => e.preventDefault());

  /* ---------- reduced motion, live in both directions ---------- */
  function pinToFinalStates() {
    seamPinned = true; seamP = -1; drawStitch();
    if (!sprung) { sqPinned = true; sprung = true; holding = false; prog = 0; sqWrite(); sq.classList.add('sprung', 'settled'); }
    $$('.reveal').forEach(el => el.classList.add('in', 'done'));
  }
  function unpinFinalStates() {
    if (seamPinned) { seamPinned = false; seamP = -1; drawStitch(); }
    if (sqPinned) { sqPinned = false; sprung = false; sq.classList.remove('sprung', 'settled'); }
  }
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  RM.addEventListener('change', e => { if (e.matches) pinToFinalStates(); applyHeroMode(); });
  if (RM.matches) pinToFinalStates();
  applyHeroMode();


  /* ---------- after a signup Shopify reloads the page: bring the visitor back to the offer ---------- */
  if (/customer_posted=true/.test(location.search)) $('#offer').scrollIntoView();
})();
